import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {SearchOutlined, ArrowLeftOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import history from '../../../routes/history'
const storage = window.localStorage

@inject('marketingSmsManagementDetailsStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    record: this.props?.location?.state?.record,
    type: this.props?.location?.state?.type
  }
  formRef = React.createRef()

  componentDidMount() {
    const {marketingSmsManagementDetailsStore, accountStore, location} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    marketingSmsManagementDetailsStore.onSearchJobAction({
      taskGroupId: location?.search?.split('?')[1]?.split('&')[0],
      isHistory: Number(location?.search?.split('&')[1]),
      status: '',
      phone: '',
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      page: 1, 
      size: PAGE_SIZE_DEFAULT
    })
    marketingSmsManagementDetailsStore.onGetStatus(location?.search?.split('?')[1]?.split('&')[0])
  }

  handleSearch = () => {
    const {marketingSmsManagementDetailsStore, accountStore, location} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'taskGroupId': location?.search?.split('?')[1]?.split('&')[0],
        'isHistory': Number(location?.search?.split('&')[1]),
        'status': fieldsValue?.status,
        'phone': fieldsValue?.phone,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      marketingSmsManagementDetailsStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleBack = () => {
      history.push(`/smsManagement`,{taskType: this.state.type})
  }

  render() {
    const { marketingSmsManagementDetailsStore, t } = this.props
    const { statusList } = marketingSmsManagementDetailsStore
    //较验手机号的正则表达式
    const regPhone = /^((1[3,5,7,8,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[7]))\d{8}$/
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.SmsManagementDetails`)} - {this.state.record?.taskName}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="status" label={t(`marketingManagement.receiptStatus`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {statusList?.map(item => (<Select.Option key={item} value={item}>{item}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="phone" label={t(`marketingManagement.phone`)}
                // rules={[{
                //   message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.phone`)} ${t(`general.withoutSpecialChats`)}`,
                //   pattern: new RegExp(regPhone)
                // }]}
              >
                <Input maxLength={11} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={12} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button type="primary" onClick={() => this.handleBack()} icon={<ArrowLeftOutlined/>}>{t(`general.back`)}</Button>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

export default withTranslation()(SearchForm)
